export default "__VITE_ASSET__BRLuz7xL__"